import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BorderStyleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"border_style"}/>
}
